import React from "react";
import {FieldArray, Formik, FormikProps} from "formik";
import {AddressItem, NewPlanAddressForm} from "../../../../../types/newPlanItem";
import {initialAddressItem, initialValues, ValidationSchema} from "./formik";
import {Button, Divider, Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {AddressItem as AddressItemComponent} from "./components";
import {initialRubricItem} from "../../../NewAuction/components/Rubric/formik";

export const AddressFields = ({
                                  formikRef, editingInitialState, planItemEditing, companyId, planId, planItemId, disabled = false,
                              }: {
    formikRef: React.RefObject<FormikProps<NewPlanAddressForm>>
    editingInitialState?: NewPlanAddressForm
    planItemEditing: boolean,
    companyId?: number
    planId?: number
    planItemId?: number,
    disabled?: boolean,
}) => {
    const {t} = useTranslation();
    const onSubmit = () => {
        console.log("submit");
    };

    return <Formik
        innerRef={formikRef}
        initialValues={editingInitialState || initialValues}
        validationSchema={ValidationSchema()}
        onSubmit={onSubmit}
        validateOnMount
    >
        {(frops: FormikProps<NewPlanAddressForm>) => (
            <React.Fragment>
                <Grid container columnSpacing={3} rowSpacing={1}>
                    <Grid item xs={12} sx={{mb: 1}}>
                        <Typography variant="h6">
                            {t("cabinet.new_plan_item.sections.address")}
                        </Typography>
                    </Grid>
                </Grid>


                <FieldArray
                    name="items"
                    render={arrayHelpers => (
                        <Grid item>

                            {frops.values.items.map((item, idx) => (
                                <React.Fragment key={idx}>
                                    <AddressItemComponent idx={idx}
                                                         frops={frops} arrayHelpers={arrayHelpers} planItemEditing={planItemEditing}
                                                          companyId={companyId} planId={planId} planItemId={planItemId} disabled={disabled}
                                    />
                                </React.Fragment>
                            ))}

                            <Divider sx={{mt: 3, mb: 2, ml: "auto", mr: "auto", width: '90%'}}/>

                            <Grid item container columnSpacing={3} rowSpacing={1}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Button color="primary" variant="contained" size="small" disabled={disabled}
                                            onClick={() => arrayHelpers.push(initialAddressItem)}
                                    >
                                        {t("cabinet.new_plan_item.address.add_address")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                />
            </React.Fragment>
        )}
    </Formik>
};